import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TooltipModule } from '../../directives/tooltip/tooltip.module';
import { IconsModule } from '../../design/icons.module';
import { DialogComponent } from './dialog.component';

@NgModule({
  declarations: [DialogComponent],
  imports: [CommonModule, IconsModule, OverlayModule, PortalModule, A11yModule, TooltipModule],
  exports: [DialogComponent]
})
export class DialogModule { }
